import { useState } from 'react';
import BaseTooltip from '@primitives/BaseTooltip';
import TooltipIcon from '@repo/ui/src/components/Icons/TooltipIcon';

export interface HelpIconTooltip {
  text: string;
  altColor: string;
  border?: boolean;
  label: string;
  closeLabel: string;
}

const HelpIconTooltip = ({
  text,
  altColor,
  border = false,
  label,
  closeLabel,
}: HelpIconTooltip) => {
  const [open, setOpen] = useState(false);

  if (!text) return null;

  return (
    <BaseTooltip
      text={text}
      label={label}
      closeLabel={closeLabel}
      closeIcon
      border={border}
      onToggleOpen={setOpen}
    >
      <span className="ml-1">
        <TooltipIcon color={open ? 'var(--tra-color-action-accent-400)' : altColor} />
      </span>
    </BaseTooltip>
  );
};

export default HelpIconTooltip;
